import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-md"
      >
        <p className="text-brand-green font-mono text-sm tracking-widest mb-4">404</p>
        <h1 className="font-display text-4xl text-ink mb-4">Page not found</h1>
        <p className="text-slateline-500 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-4 justify-center">
          <Button
            variant="outline"
            className="border-slateline-200 text-slateline-600 hover:bg-slateline-100"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </Button>
          <Button
            className="bg-brand-green hover:bg-brand-greenHover text-white font-semibold"
            onClick={() => navigate("/")}
          >
            <Home className="w-4 h-4 mr-2" />
            Homepage
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
